<template>
    <ve-table
        :table-data="data"
        :cell-style-option="cellStyleOption"
        :cellSelectionOption="cellSelectionOption"
        :border-around="false"
        :border-x="true"
        :border-y="false"
        :sort-option="sortOption"
        :row-style-option="rowStyleOption"
        :virtual-scroll-option="virtualScrollOption"
        row-key-field-name="rowKey"
        class="virtual-scroll-table-shared-watchlist"
        v-bind="$attrs"
        fixed-header
    />
</template>
<script>
    import tableHelper from 'components/user/organizationreport/tables/helpers/table-helper'
    export default {
        name: 'virtual-scroll-table-shared-watchlist',
        mixins: [ tableHelper ],
        props: {
            data: {
                type: Array
            }
        },
        data () {
            return {
                virtualScrollOption: {
                    enable: true,
                    bufferScale: 10
                },
                rowStyleOption: {
                    stripe: true
                }
            }
        }
    }
</script>

<style lang="scss">
    .virtual-scroll-table-shared-watchlist {
        .table-header-cell {
            background: $gallery !important;
            font-family: Nunito-Bold, sans-serif;
            font-size: 1.4rem;
            height: 36px;
            white-space: nowrap;
        }

        .table-cell,
        .share-watchlist-user-row__column-attribute {
            &.--shared {
                color: $orange;

                .icon-checkmark {
                    margin-right: 5px;
                }
            }
            &.--not-shared {
                color: $silver_chalice;
            }
        }

        .ve-table {
            tr.ve-table-header-tr {
                height: 36px !important;

                th.ve-table-header-th {
                    vertical-align: middle;
                    padding: 5px !important;
                }
            }

            .ve-table-content {
                border-top: 1px solid $dark_gray;
            }

            tr.ve-table-body-tr {
                height: 36px !important;

                &:nth-child(2n + 1) {
                    &.ve-table-tr-highlight td,
                    &:hover td {
                        background-color: $ghost_white !important;
                    }
                }

                &:nth-child(2n) {
                    &.ve-table-tr-highlight td,
                    &:hover td {
                        background-color: $white !important;
                    }
                }

                &.ve-table-tr-highlight:nth-child(2n) td {
                    background-color: #fff !important;
                }

                td.ve-table-body-td {
                    padding: 5px !important;
                }
            }

            td.ve-table-body-td {
                padding: 6px 10px !important;
            }

            .ve-checkbox-content .ve-checkbox-inner {
                border: 1px solid $silver;
            }

            .ve-checkbox .ve-checkbox-checked .ve-checkbox-inner {
                background-color: $orange;
                border-color: $orange;
            }

            .ve-checkbox .ve-checkbox-indeterminate .ve-checkbox-inner {
                &:after {
                    background-color: $orange;
                }
            }
        }

        [class*="mobile"] & {
            .share-watchlist-user-row {
                display: flex;
                font-size: 1.3rem;
                color: $black;

                &__column-name {
                    font-family: Nunito-Regular, sans-serif;
                    font-weight: 600;
                    flex: 1 25%;
                }

                &__column-attribute {
                    font-family: Nunito-Bold, sans-serif;
                    font-weight: 400;
                    flex: 1 75%;
                    max-width: 75%;
                }
            }
        }
    }
</style>
